import { CFlex, DText, Flex } from '../../../styles/MarketStyles'
import Text from '../../../utils/Text'
import { SOCKET_URL } from '../../../constants/urls'
import styled from 'styled-components'
import { formatNumber } from '../../../utils/common'
import { IoIosClose } from 'react-icons/io'
import { useRef } from 'react'
import html2canvas from 'html2canvas'

const SuccessInvoice = (props) => {
	const { data, tradeType, onClose } = props
	const { otc, withdraw } = data

	const printRef = useRef()

	const TradeColor = tradeType === 'buy' ? '#1ce087' : '#e9106c'
	const OtcStatusColor = !!otc ? '#1ce087' : '#e9106c'
	const WithdrawStatusColor = !!withdraw ? '#1ce087' : '#e9106c'

	const handleDownloadImage = async () => {
		const element = printRef.current
		const canvas = await html2canvas(element, { useCORS: true })

		const data = canvas.toDataURL('image/jpg')
		const link = document.createElement('a')

		if (typeof link.download === 'string') {
			link.href = data
			link.download = 'image.jpg'

			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		} else {
			window.open(data)
		}
	}

	return (
		<>
			<Wrapper ref={printRef}>
				<CloseIconWrapper>
					<CloseIcon size={20} onClick={onClose} />
				</CloseIconWrapper>
				<DText fontSize={'m'} color={TradeColor} style={{ textAlign: 'left' }}>
					<Text tid={`${tradeType}-invoice`} />
				</DText>
				<img
					src={SOCKET_URL + `assets/icon/${otc?.coin}.png`}
					alt={' '}
					width={'54px'}
					style={{ margin: '8px' }}
				/>
				<DText fontSize={'s'} main>
					{otc?.coin?.toUpperCase()}
				</DText>
				<Flex fw>
					<SuccessInvoiceCard>
						<CFlex fw>
							<DText fontSize={'m'} primary>
								<Text tid={'order-detail'} />
							</DText>
							<InvoiceRow>
								<DText fontSize={'s'} main>
									<Text tid={'id'} /> :
								</DText>
								<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
									{otc?._id}
								</DText>
							</InvoiceRow>
							<InvoiceRow>
								<DText fontSize={'s'} main>
									<Text tid={'amount'} /> :
								</DText>
								<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
									{formatNumber(otc?.amount)} {otc?.coin?.toUpperCase()}
								</DText>
							</InvoiceRow>
							<InvoiceRow>
								<DText fontSize={'s'} main>
									<Text tid={'price'} /> :
								</DText>
								<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
									{formatNumber(otc?.price)} IRT
								</DText>
							</InvoiceRow>
							<InvoiceRow>
								<DText fontSize={'s'} main>
									<Text tid={'priceUnit'} /> :
								</DText>
								<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
									{formatNumber(otc?.priceUnit)} IRT
								</DText>
							</InvoiceRow>
							<InvoiceRow>
								<DText fontSize={'s'} main>
									<Text tid={'fee'} /> :
								</DText>
								<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
									{formatNumber(otc?.wage)} {tradeType === 'buy' ? otc?.coin?.toUpperCase() : 'IRT'}
								</DText>
							</InvoiceRow>
							<InvoiceRow>
								<DText fontSize={'s'} main>
									<Text tid={'afterWage'} /> :
								</DText>
								<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
									{formatNumber(otc?.afterWage)}{' '}
									{tradeType === 'buy' ? otc?.coin?.toUpperCase() : 'IRT'}
								</DText>
							</InvoiceRow>
							<InvoiceRow>
								<DText fontSize={'s'} main>
									<Text tid={'status'} /> :
								</DText>
								<DText fontSize={'s'} color={OtcStatusColor} style={{ direction: 'ltr' }}>
									<Text tid={!!otc ? 'success' : 'fail'} />
								</DText>
							</InvoiceRow>
						</CFlex>
					</SuccessInvoiceCard>
				</Flex>
				{withdraw && (
					<Flex fw>
						<SuccessInvoiceCard>
							<CFlex fw>
								<DText fontSize={'m'} primary>
									<Text tid={'withdraw-detail'} />
								</DText>
								<InvoiceRow>
									<DText fontSize={'s'} main>
										<Text tid={'id'} /> :
									</DText>
									<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
										{withdraw?._id}
									</DText>
								</InvoiceRow>
								<InvoiceRow>
									<DText fontSize={'s'} main>
										<Text tid={'amount'} /> :
									</DText>
									<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
										{formatNumber(withdraw?.amount)}{' '}
										{tradeType === 'buy' ? otc?.coin?.toUpperCase() : 'IRT'}
									</DText>
								</InvoiceRow>
								<InvoiceRow>
									<DText fontSize={'s'} main>
										<Text tid={'fee'} /> :
									</DText>
									<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
										{formatNumber(withdraw?.amount - withdraw?.totalAmount)}{' '}
										{tradeType === 'buy' ? otc?.coin?.toUpperCase() : 'IRT'}
									</DText>
								</InvoiceRow>
								<InvoiceRow>
									<DText fontSize={'s'} main>
										<Text tid={'afterWage'} /> :
									</DText>
									<DText fontSize={'s'} primary style={{ direction: 'ltr' }}>
										{formatNumber(withdraw?.totalAmount)}{' '}
										{tradeType === 'buy' ? otc?.coin?.toUpperCase() : 'IRT'}
									</DText>
								</InvoiceRow>
								<InvoiceRow>
									<DText fontSize={'s'} main>
										<Text tid={'status'} /> :
									</DText>
									<DText fontSize={'s'} color={WithdrawStatusColor} style={{ direction: 'ltr' }}>
										<Text tid={!!withdraw ? 'success' : 'fail'} />
									</DText>
								</InvoiceRow>
							</CFlex>
						</SuccessInvoiceCard>
					</Flex>
				)}
			</Wrapper>
			<DownloadBtn onClick={handleDownloadImage}>
				<Text tid={'download'} />
			</DownloadBtn>
		</>
	)
}

const Wrapper = styled(CFlex)`
	width: 100%;
	background-color: ${(props) => props.theme.primaryBg};
	word-wrap: normal;
	// letter-spacing: normal;
	border-radius: 4px;
	padding: 2px;
`

const SuccessInvoiceCard = styled.div`
	width: 100%;
	border-radius: 4px;
	background-color: ${(props) => props.theme.mainBg};
	padding: 10px;
	margin: 8px 0;
	border: 1px solid ${(props) => props.theme.color}10;
`

const InvoiceRow = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 4px 0;
`

const CloseIconWrapper = styled.div`
	position: absolute;
	top: 0;
	right: 0;
`

const CloseIcon = styled(IoIosClose)`
	color: ${(props) => props.theme.color};
	cursor: pointer;
`

const DownloadBtn = styled.div`
	width: 100%;
	height: 42px;
	border-radius: 4px;
	background-color: ${(props) => props.theme.mainOrange}90;
	transition: all 0.3s;
	cursor: pointer;
	margin-top: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #191c20;
	font-size: 0.95rem;
	// letter-spacing: 0;

	&:hover {
		background-color: ${(props) => props.theme.mainOrange};
	}
`

export default SuccessInvoice
